module.exports = __webpack_public_path__ + "img/no_data.cb61ac4f.svg";